import { render, staticRenderFns } from "./ChooseSessionDialog.vue?vue&type=template&id=6c5f0f3d&"
import script from "./ChooseSessionDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseSessionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports